import { useState, useEffect, useRef } from "react";
import { use3DEffect } from "../../../hooks/use3DEffect";
import { API } from "../../../api";

export default function ScheduleBlock({ dataSchedule }) {;
  const ref = useRef(null);
  use3DEffect(ref);

  const [schedule, setSchedule] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchSchedule() {
      try {
        setLoading(true);
        const data = await API.get("calendar");
        const parsed = data.map(d => ({
          ...d,
          slots: typeof d.slots === 'string' ? JSON.parse(d.slots) : d.slots
        }));
        
        setSchedule(parsed);
      } catch (error) {
        console.error("Erreur chargement horaires:", error); // FB init avec 7 jours vides \\
        setSchedule(Array.from({ length: 7 }, (_, i) => ({ day_of_week: i + 1, slots: [] })));
      } finally {
        setLoading(false);
      }
    }
    fetchSchedule();
  }, []);

  const daysFR = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];

  return (
    <div ref={ref} className="schedule-block">
      <h2 className="Titre-Horaire-ouverture">Horaires d'ouverture</h2>

      {loading ? (
        <div className="schedule-loading">Chargement...</div>
      ) : (
        daysFR.map((label, index) => {
          const dayNum = index + 1;
          const dayData = schedule.find(d => d.day_of_week === dayNum);
          
          if (!dayData) return null;

          const slots = dayData.slots || [];
          const isClosed = dayData.is_closed || slots.length === 0;

          return (
            <div className="day-time" key={dayNum}>
              <div className="day">{label}</div>
              <div className="time">
                {isClosed ? (
                  <span className="closed-label">Fermé</span>
                ) : (
                  slots.map((slot, idx) => (
                    <div key={idx} className="time-slot">{slot.opens_at} - {slot.closes_at}</div>
                  ))
                )}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}